import React from 'react';

import Logo from './Logo';
import DefaultLogo from './DefaultLogo';

const defaultImage = <DefaultLogo />;

function LogoWrapper(props) {
  const {
    align,
    className,
    children,
    ...restProps
  } = props;

  const logoElement = (
    <div className={className} key="logo">
      <Logo
        {...restProps}
        align={align}
        defaultImage={defaultImage}
      />
    </div>
  );

  return (
    <React.Fragment>
      { align === 'right' ? [children, logoElement] : [logoElement, children] }
    </React.Fragment>
  );
}

export default LogoWrapper;